import type { InternalAxiosRequestConfig } from "axios";
import { getAuthToken } from "../../packages/auth";
import { isAxiosRequestConfigWithAuth } from "./AxiosRequestConfigWithAuth";

const AUTH_ERROR_MESSAGE =
	"Missing ID token: No authentication token was found." as const;

const createAuthInterceptor =
	() => async (config: InternalAxiosRequestConfig) => {
		try {
			if (!isAxiosRequestConfigWithAuth(config)) return config;
			if (!config.includeAuth) return config;
			const auth = getAuthToken();
			if (!auth) throw new Error(AUTH_ERROR_MESSAGE);
			config.headers.Authorization = auth;
			return config;
		} catch (err) {
			return Promise.reject(err);
		}
	};

export default createAuthInterceptor;
